import { gql } from "@apollo/client";

export const checkWorkerPhoneQuery = gql`
  query workerPhoneTaken($phone: String!) {
    workerPhoneTaken(phone: $phone)
  }
`;
export default checkWorkerPhoneQuery;
